import React from 'react';
import components from 'store/constant';
import { Link } from 'react-router-dom';
import T from 'components/Common/text/T';
import { icon_dof } from 'components/base/images';
import { logoMapper } from 'lib/mapper';
import { shallowEqual, useSelector } from 'react-redux';

function NavLogo(props) {
  let toggleClass = ['mobile-menu'];
  if (props.collapseMenu) {
    toggleClass = [...toggleClass, 'on'];
  }
  const { oemState } = useSelector(
    state => ({
      oemState: state.app?.oemState || 'dof',
    }),
    shallowEqual,
  );

  return (
    <>
      <div className="navbar-brand header-logo">
        {/* <Link to={components.BLANK_LINK} className="b-brand"> */}
        <Link to="/auth/home" className="b-brand">
          <div className="b-bg">
            <img src={logoMapper[`${oemState}_favicon`]} className="dof_icon" />
            {/* <i className="feather icon-trending-up" /> */}
            {/* <img
                            src={`${process.env.PUBLIC_URL}/favicon.ico`}
                            loading="lazy"
                        /> */}
          </div>
          <span className="b-title">
            {oemState === 'marathon' ? 'Marathon' : <T>SERVICE_NAME</T>}
          </span>
        </Link>
        <Link
          to={components.BLANK_LINK}
          className={toggleClass.join(' ')}
          id="mobile-collapse"
          onClick={props.onToggleNavigation}
        >
          <span />
        </Link>
      </div>
    </>
  );
}

export default NavLogo;
